module.exports = __webpack_public_path__ + "assets/icn-consultation-deselected.d608a990.svg";